import invoiceHandler from "../../services/Invoice";

export default {
    async loadInvoices({commit, dispatch}, payload) {
        const {data} = await invoiceHandler.all(payload);

        commit('SET_INVOICES', data);
    },
    async invoiceSearch({commit, dispatch}, payload) {
        return  invoiceHandler.search(payload);
    },
    async storeInvoice({commit, dispatch}, payload) {
        return invoiceHandler.store(payload);
    },
    async getByInvoiceId({commit, dispatch}, payload) {
        return invoiceHandler.get(payload);
    },
    async updateManualPayment({commit, dispatch}, payload) {
        return invoiceHandler.updateManualPayment(payload);
    },
    async updateInvoice({commit, dispatch}, payload) {
        return invoiceHandler.update(payload);
    },
    async destroyInvoice({commit, dispatch}, payload) {
        return invoiceHandler.destroy(payload);
    },
    async restoreInvoice({commit, dispatch}, payload) {
        return invoiceHandler.restore(payload);
    },
    async resetInvoiceHandler({commit, dispatch}, payload) {
        return invoiceHandler.restoreInvoice(payload);
    },
    async invoiceSoftDeleteHandler({commit, dispatch}, payload) {
        return invoiceHandler.softDelete(payload);
    },
    async resendMailHandler({commit, dispatch}, payload) {
        return invoiceHandler.resendPaymentMail(payload);
    },
    async sendReminderMail({commit, dispatch}, payload) {
        return invoiceHandler.reminderMail(payload);
    },
    async sendAfterReminderMail({commit, dispatch}, payload) {
        return invoiceHandler.afterReminderMail(payload);
    },
    async loadInvoiceReportBySite({commit, dispatch}, payload) {
        const {data} = await invoiceHandler.invoiceReportBySite(payload);
        commit('SET_INVOICES', data);
    },
    async loadSiteSummaryReports({commit, dispatch}, payload) {
        const {data} = await invoiceHandler.siteSummaryReports(payload);
        commit('SET_SITE_SUMMARY', data);
    },
    async loadInvoiceSitesReportBySite({commit, dispatch}, payload) {
      const {data} = await invoiceHandler.invoiceSummaryReportBySite(payload);
      commit('SET_SITE_SUMMARY_REPORT', data)
    },
    async republishInvoice({commit, dispatch}, payload) {
        return invoiceHandler.republish(payload);
    },
    async refundInvoice({commit, dispatch}, payload) {
        return invoiceHandler.refund(payload);
    },
    async refundMergedInvoice({commit, dispatch}, payload) {
        return invoiceHandler.mergedRefund(payload);
    },
    async invoiceMarkAsRead({commit, dispatch}, payload) {
        return invoiceHandler.invoiceMarkAsRead(payload);
    },
    async republishedEmail({commit, dispatch}, payload) {
        return invoiceHandler.republishedEmail(payload);
    }
}
